(function(document) {

    let selectors = {
        tablesSizes: '.table-sizes:not(.cross-size-table)',
        selectGender: '.gender-step--page',
        tagsGender: '.tag_ricercae--page',
        selectType: '.find-size__type--page',
        tagsType: '.tag_find_size__type--page',
        selectNum: '.find-size__num--page',
        tagsNum: '.tag_find_size__num--page',
        suggestSizesFilter: '.filter-size__suggest',
        suggestSizesGroup: '.suggest-size-group',
        suggestSizes: '.suggest-size',
        suggestSizesEmpty: '.suggest-size--empty',
        // suggestTextAdvise: '.suggest-text-advise',
        selectStyles: '.select-style'
    };
  
    let tablesSizes = document.querySelectorAll(selectors.tablesSizes)
    let selectGender = document.querySelector(selectors.selectGender)
    let tagsGender = document.querySelectorAll(selectors.tagsGender)
    let selectType = document.querySelector(selectors.selectType)
    let tagsType = document.querySelectorAll(selectors.tagsType)
    let selectNum = document.querySelector(selectors.selectNum)
    let tagsNum = document.querySelectorAll(selectors.tagsNum)
    let suggestSizesFilter = document.querySelector(selectors.suggestSizesFilter)
    let suggestSizesGroup = document.querySelector(selectors.suggestSizesGroup)
    let suggestSizes = document.querySelectorAll(selectors.suggestSizes)
    let suggestSizesEmpty = document.querySelector(selectors.suggestSizesEmpty)
    // let suggestTextAdvise = document.querySelector(selectors.suggestTextAdvise)
    let selectStyles = document.querySelectorAll(selectors.selectStyles)

    window.tagGenderSelected = ""
    window.tagTypeSelected = ""
    window.tagNumSelected = ""

    if (tablesSizes) {
        tablesSizes.forEach(function(tableSizes){
            let tableThs = tableSizes.querySelectorAll("tr th");
            let tableTds = tableSizes.querySelectorAll("tr td");
            tableThs.forEach(function(tableTh){
                tableTh.addEventListener('mouseenter', (event) => {
                    tableTh.classList.add("selected")
                });
                tableTh.addEventListener('mouseleave', (event) => {
                    tableTh.classList.remove("selected")
                });
            })
            tableTds.forEach(function(tableTd){

                let indexY = tableTd.cellIndex
                let rowOfTd = tableTd.closest('tr');
                let indexX = rowOfTd.rowIndex

                tableTd.addEventListener('mouseenter', (event) => {

                    tableTd.classList.add("selected")

                    tablesSizes.forEach(function(tableSizes_check){

                        let tableThs_check = tableSizes_check.querySelectorAll("tr th");
                        let tableTds_check = tableSizes_check.querySelectorAll("tr td");

                        tableThs_check.forEach(function(tableTh_check){
                            if(tableTh_check.cellIndex == indexY) {
                                tableTh_check.classList.add("selected")
                            }
                        })
                        tableThs.forEach(function(tableThs_check_localTable){
                            let rowOfTh_check = tableThs_check_localTable.closest('tr');
                            let indexX_check = rowOfTh_check.rowIndex
                            if(indexX_check == indexX) {
                                tableThs_check_localTable.classList.add("selected")
                            }
                        })

                        tableTds_check.forEach(function(tableTd_check){
                            if(tableTd_check.cellIndex == indexY) {
                                tableTd_check.classList.add("selected")
                            }
                        })
                        tableTds.forEach(function(tableTd_check_localTable){
                            let rowOfTd_check = tableTd_check_localTable.closest('tr');
                            let indexX_check = rowOfTd_check.rowIndex
                            if(indexX_check == indexX) {
                                tableTd_check_localTable.classList.add("selected")
                            }
                        })

                    })

                });
                tableTd.addEventListener('mouseleave', (event) => {

                    tableTd.classList.remove("selected")

                    tablesSizes.forEach(function(tableSizes_check){
                        let tableThs_check = tableSizes_check.querySelectorAll("tr th");
                        let tableTds_check = tableSizes_check.querySelectorAll("tr td");

                        tableThs_check.forEach(function(tableTh_check){
                            if(tableTh_check.cellIndex == indexY) {
                                tableTh_check.classList.remove("selected")
                            }
                        })
                        tableThs.forEach(function(tableThs_check_localTable){
                            let rowOfTh_check = tableThs_check_localTable.closest('tr');
                            let indexX_check = rowOfTh_check.rowIndex
                            if(indexX_check == indexX) {
                                tableThs_check_localTable.classList.remove("selected")
                            }
                        })

                        tableTds_check.forEach(function(tableTd_check){
                            if(tableTd_check.cellIndex == indexY) {
                                tableTd_check.classList.remove("selected")
                            }
                        })
                        tableTds.forEach(function(tableTd_check_localTable){
                            let rowOfTd_check = tableTd_check_localTable.closest('tr');
                            let indexX_check = rowOfTd_check.rowIndex
                            if(indexX_check == indexX) {
                                tableTd_check_localTable.classList.remove("selected")
                            }
                        })

                    })
                });
            })
        })
    }


    // selectStyles.forEach(function(selectStyle) {
    //     selectStyle.addEventListener('click', (event) => {
    //         let singleSelect = selectStyle.querySelector(".select-style__single--select")
    //         if (singleSelect) {
    //             singleSelect.remove()
    //         }
    //     })
    // })

    tagsGender.forEach(function(tagGender) {
        tagGender.addEventListener('click', (event) => {

            selectGender.prepend(tagGender)

            selectType.classList.remove("locked")
            tagGenderSelected = tagGender.getAttribute("attr-filter")

            let singleSelect = tagGender.parentNode.querySelector(".select-style__single--select")
            if (singleSelect) {
                singleSelect.remove()
            }

        })
    })
    tagsType.forEach(function(tagType) {
        tagType.addEventListener('click', (event) => {

            selectType.prepend(tagType)

            selectNum.classList.remove("locked")

            tagTypeSelected = tagType.getAttribute("attr-find")
            console.log(tagTypeSelected)

            tagsNum.forEach(function(tagNum) {
                
                let tagNum_gender = tagNum.getAttribute("attr-gender")
                let tagNum_type = tagNum.getAttribute("attr-type")

                if  (
                        (tagNum_gender == tagGenderSelected)
                        &&
                        (tagNum_type == tagTypeSelected)
                    ) 
                    {
                        tagNum.classList.remove("hide")
                    } else {
                        tagNum.classList.add("hide")
                    }

            })

            let singleSelect = tagType.parentNode.querySelector(".select-style__single--select")
            if (singleSelect) {
                singleSelect.remove()
            }

        })
    })
    tagsNum.forEach(function(tagNum) {
        tagNum.addEventListener('click', (event) => {
            selectNum.prepend(tagNum)
            var attrSuggest = tagNum.getAttribute("attr-suggest")
            var attrSuggestArray = attrSuggest.split(",")

            suggestSizesGroup.classList.remove("hidden")
            suggestSizesEmpty.classList.add("hide")

            suggestSizes.forEach(function(suggestSize) {
                var attrFilter = suggestSize.getAttribute("attr-filter")
                if (attrSuggestArray.includes(attrFilter)) {
                    suggestSize.classList.remove("hide")
                } else {
                    suggestSize.classList.add("hide")
                }
            })

            let singleSelect = tagNum.parentNode.querySelector(".select-style__single--select")
            if (singleSelect) {
                singleSelect.remove()
            }
        })
    })

})(document);
  